import React from 'react';
import { Dropdown, Menu } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
// UTILITY
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import store from 'app/store';
import { Type, Icon as pointIcon } from '../../../../constants/TourPoints';
import { getPointIcon } from '../extraFuncs';
// IMAGES
import pointStart from '../../../../../static/images/icons/start_point.svg';
import pointVia from '../../../../../static/images/icons/via_sm_deact.png';
import pointEnd from '../../../../../static/images/icons/end_point.svg';

import { setPointType } from '../../../../actions/FullTour/full_tour_view.action';

export const imgPoint = (dataPoint) => {
  let img;
  switch (dataPoint.type) {
    case 'start':
      img = <img src={pointStart} alt="img" />;
      break;
    case 'end':
      img = <img src={pointEnd} alt="img" />;
      break;
    default:
      img = <img src={pointVia} alt="img" />;
  }

  return img;
};

export const changePositionPoint = (dataPoint) => {
  const imgStyle = {
    width: 15,
    height: 20,
  };
  const spanStyle = {
    marginLeft: 5,
  };
  const onClickHandle = ({ key }) => {
    store.dispatch(setPointType(key));
    publish(way.DRIVE_MAP_POINT_SET_TYPE, {
      customId: dataPoint.id,
      type: key,
    });
  };

  const menu = (
    <Menu onClick={onClickHandle}>
      <Menu.Item key={Type.START}>
        <img src={pointIcon.start} alt="img" style={imgStyle} />
        <span style={spanStyle}>Start</span>
      </Menu.Item>
      <Menu.Item key={Type.VIA}>
        <img src={pointIcon.via} alt="img" style={imgStyle} />
        <span style={spanStyle}>Via</span>
      </Menu.Item>
      <Menu.Item key={Type.END}>
        <img src={pointIcon.end} alt="img" style={imgStyle} />
        <span style={spanStyle}>End</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="chooseTourType">
      <Dropdown overlay={menu} trigger={['click']}>
        <div>
          {getPointIcon(dataPoint)}
          <CaretDownOutlined style={{ color: '#333' }} />
        </div>
      </Dropdown>
    </div>
  );
};
